import React from 'react';
import { translate } from 'react-i18next';

class UnavailablesFullDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.setStartDate = this.setStartDate.bind(this);
  }

  componentDidMount() {
    this.initDatePickers(this.props.defaultDate);
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultDate !== prevProps.defaultDate) {
      this.updateDatePickers(this.props.defaultDate);
    }
  }

  updateDatePickers(date) {
    if (this.startPicker) {
      this.startPicker.setDate(date);
    }

    if (this.endPicker) {
      this.endPicker.setDate(date);
    }
  }

  initDatePickers(date) {
    const that = this;
    const startElement = document.getElementById('timeoff-start-date');
    const endElement = document.getElementById('timeoff-end-date');
    const i18nConfig = {
      months: moment.localeData()._months,
      weekdays: moment.localeData()._weekdays,
      weekdaysShort: moment.localeData()._weekdaysShort
    };

    this.endPicker = new Pikaday({
      field: endElement,
      format: 'YYYY-MM-DD',
      defaultDate: date,
      setDefaultDate: true,
      minDate: moment().toDate(),
      i18n: i18nConfig,
      onSelect() {
        that.setEndDate();
        endElement.parentNode.classList.remove('error');
      },
    });

    this.startPicker = new Pikaday({
      field: startElement,
      format: 'YYYY-MM-DD',
      minDate: moment().toDate(),
      defaultDate: date,
      setDefaultDate: true,
      i18n: i18nConfig,
      onSelect() {
        that.setStartDate();
        that.endPicker.setMinDate(this.getMoment().toDate());
        startElement.parentNode.classList.remove('error');
      },
    });

    this.props.startsAtHandler(date);
    this.props.endsAtHandler(date);
  }

  // Update parent's state: startsAt
  setStartDate() {
    this.props.startsAtHandler(this.startPicker.getDate());
  }

  // Update parent's state: endsAt
  setEndDate() {
    this.props.endsAtHandler(this.endPicker.getDate());
  }

  render() {
    return (
      <div className="form-field-group">
        <div className="form-group-item">
          <label htmlFor="timeoff-start-date">{this.props.t('UnavailablesFullDatePicker.starts')}</label>
          <input
            id="timeoff-start-date"
            name="timeoff-start-date"
            className="datepicker"
            type="text"
            onChange={this.setStartDate}
          />
        </div>
        <div className="form-group-item">
          <label htmlFor="timeoff-end-date">{this.props.t('UnavailablesFullDatePicker.ends')}</label>
          <input
            id="timeoff-end-date"
            type="text"
            className="datepicker"
            name="timeoff-end-date"
            onChange={this.setEndDate}
          />
        </div>
      </div>
    );
  }
}

export default translate()(UnavailablesFullDatePicker);
